import logout from './logout'

/**
 * @param {number} status
 */
const checkStatus = (status, router) => {
  const logoutCodes = [401]
  if (logoutCodes.includes(status)) {
    logout()
    router.push({ name: 'Login' })
  }
}

export default checkStatus
